/*
 * Packs de tetinas en la ficha de la tetina (bundles de la app Happymami → Bundles).
 *
 * Lee de /apps/hm-menus/bundles los packs cuyas piezas son solo esta tetina (ej. «1 Tetina» y
 * «Set de 2 tetinas») y los ofrece como filas. Un pack de 1 unidad compra con el formulario normal.
 * Un pack de varias unidades añade una línea por unidad (con una propiedad oculta distinta para que
 * Shopify no las junte) y el mismo _bundle_id: la función de checkout las agrupa y cobra el precio
 * del pack. Aquí no se calcula ni se aplica ningún descuento.
 *
 * Un pack también puede llevar UNA pieza más de otro producto (ej. «Pack tetina + biberón»): se elige su
 * variante en un selector bajo las filas y se añade con el mismo _bundle_id.
 */
(function () {
  'use strict';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function msg(path, fallback) {
    try {
      if (typeof window.hmT === 'function') {
        var value = window.hmT(path);
        if (value) return value;
      }
    } catch (e) {}
    return fallback;
  }

  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  function init(box) {
    if (box.dataset.hmBound === '1') return;
    box.dataset.hmBound = '1';

    var productId = box.getAttribute('data-product') || '';
    var locale = (box.getAttribute('data-locale') || 'es').toLowerCase();
    var url =
      box.getAttribute('data-url') +
      '?product=' + encodeURIComponent(productId) +
      '&market=' + encodeURIComponent(box.getAttribute('data-market') || '') +
      '&locale=' + encodeURIComponent(locale) +
      '&mode=generic&detail=1';
    var info = box.closest('.product__info-container');
    var state = { packs: [], pack: '', variants: {}, shown: {} };
    // Colores de respaldo del biberón por si Shopify no devuelve el del swatch.
    var SWATCH_FALLBACK = { 'Menta Suave': '#b7d4c8', 'Rosa Palo': '#e8b4ae', 'Violeta Seda': '#6f6280' };

    // Unidades de ESTA tetina del pack (las que se añaden desde el formulario de la ficha).
    function isOwnTeat(slot) {
      return slot.role === 'tetina' && slot.products.indexOf(productId) !== -1;
    }

    function units(pack) {
      return pack.slots.reduce(function (sum, slot) {
        return isOwnTeat(slot) ? sum + slot.qty : sum;
      }, 0);
    }

    // La pieza de otro producto (el biberón), si el pack la lleva.
    function companion(pack) {
      for (var i = 0; i < pack.slots.length; i += 1) {
        if (!isOwnTeat(pack.slots[i])) return pack.slots[i];
      }
      return null;
    }

    function companionItem(slot) {
      return slot && slot.items && slot.items.length ? slot.items[0] : null;
    }

    function companionVariant(pack) {
      var item = companionItem(companion(pack));
      if (!item) return null;
      var wanted = state.variants[pack.id];
      var fallback = null;
      for (var i = 0; i < item.variants.length; i += 1) {
        var variant = item.variants[i];
        if (variant.id === wanted && variant.available) return variant;
        if (!fallback && variant.available) fallback = variant;
      }
      return fallback;
    }
    var originalPrice = null;

    function current() {
      for (var i = 0; i < state.packs.length; i += 1) {
        if (state.packs[i].id === state.pack) return state.packs[i];
      }
      return null;
    }

    function priceBox() {
      return info && info.querySelector('[id^="price-"] .price');
    }

    // Al elegir un set el precio de la ficha pasa a ser el del pack (original tachado y rebajado).
    function paintPrice(pack) {
      var price = priceBox();
      if (!price) return;
      if (originalPrice === null) originalPrice = { html: price.innerHTML, onSale: price.classList.contains('price--on-sale') };
      if (!pack || units(pack) < 2) {
        price.innerHTML = originalPrice.html;
        price.classList.toggle('price--on-sale', originalPrice.onSale);
        return;
      }
      var container = el('div', 'price__container');
      var sale = el('div', 'price__sale');
      if (pack.compare) sale.appendChild(el('s', 'price-item price-item--regular', pack.compare));
      sale.appendChild(el('span', 'price-item price-item--sale price-item--last', pack.price));
      container.appendChild(sale);
      price.textContent = '';
      price.appendChild(container);
      price.classList.toggle('price--on-sale', !!pack.compare);
    }

    function select(id) {
      state.pack = id;
      var pack = current();
      var multi = !!pack && units(pack) > 1;
      if (info) info.classList.toggle('hm-set-selected', multi);
      paintPrice(pack);
      render();
    }

    function isColorOption(name) {
      return /colou?r|tono|colore|farbe|^cor$|couleur|kolor/i.test(name || '');
    }

    // Elige un valor de una opción del biberón: la variante más cercana a lo que ya había elegido.
    function pickValue(pack, item, optionIndex, value) {
      var current = companionVariant(pack);
      var best = null;
      var bestScore = -1;
      item.variants.forEach(function (variant) {
        if (!variant.available || variant.options[optionIndex] !== value) return;
        var score = 0;
        if (current) {
          variant.options.forEach(function (option, index) {
            if (index !== optionIndex && option === current.options[index]) score += 1;
          });
        }
        if (score > bestScore) {
          best = variant;
          bestScore = score;
        }
      });
      if (best) state.variants[pack.id] = best.id;
      render();
    }

    function hexOf(item, optionIndex, value) {
      var group = item.optionValues && item.optionValues[optionIndex];
      if (group) {
        for (var i = 0; i < group.values.length; i += 1) {
          if (group.values[i].name === value && group.values[i].color) return group.values[i].color;
        }
      }
      return SWATCH_FALLBACK[value] || '';
    }

    // Color en círculos y el resto de opciones en píldoras, con la foto de la variante a la derecha:
    // igual que el selector del biberón.
    function optionsPanel(pack, item) {
      var chosen = companionVariant(pack);
      var panel = el('div', 'hm-tp__options hm-option--preview');
      var preview = el('span', 'hm-preview');
      preview.setAttribute('aria-hidden', 'true');
      var src = (chosen && chosen.image) || item.image || '';
      var before = state.shown[pack.id] || '';
      // La miniatura nueva entra en fundido sobre la anterior (el panel se vuelve a pintar al elegir).
      var fadeFrom = before && before !== src ? before : '';
      function thumb(url, on) {
        var img = el('img', 'hm-preview__img' + (on ? ' is-on' : ''));
        img.alt = '';
        img.width = 68;
        img.height = 68;
        img.loading = 'lazy';
        if (url) img.src = url;
        preview.appendChild(img);
        return img;
      }
      if (fadeFrom && src) {
        var oldImg = thumb(fadeFrom, true);
        var newImg = thumb(src, false);
        var reveal = function () {
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              newImg.classList.add('is-on');
              oldImg.classList.remove('is-on');
            });
          });
        };
        if (newImg.complete) reveal();
        else newImg.addEventListener('load', reveal);
      } else {
        thumb(src, true);
      }
      state.shown[pack.id] = src;
      panel.appendChild(preview);
      (item.options || []).forEach(function (name, index) {
        var values = [];
        item.variants.forEach(function (variant) {
          var value = variant.options[index];
          if (variant.available && values.indexOf(value) === -1) values.push(value);
        });
        if (values.length < 2 && item.options.length > 1) return;
        var group = el('div', 'hm-option');
        group.appendChild(el('p', 'hm-option__label', name));
        var list = el('div', isColorOption(name) ? 'hm-swatches' : 'hm-pills');
        list.setAttribute('role', 'list');
        values.forEach(function (value) {
          var on = !!chosen && chosen.options[index] === value;
          var button = el('button', isColorOption(name) ? 'hm-swatch' + (on ? ' is-selected' : '') : 'hm-pill' + (on ? ' is-selected' : ''));
          button.type = 'button';
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (isColorOption(name)) {
            var hex = hexOf(item, index, value);
            button.setAttribute('aria-label', value);
            button.title = value;
            if (hex) {
              button.style.setProperty('--hm-swatch', hex);
              button.style.backgroundColor = hex;
            }
          } else {
            button.textContent = value;
          }
          button.addEventListener('click', function () {
            pickValue(pack, item, index, value);
          });
          list.appendChild(button);
        });
        group.appendChild(list);
        panel.appendChild(group);
      });
      return panel;
    }

    // Estilo de la tarjeta que se edita en la app: borde, badge, texto inferior y tamaños (vacío = el del tema).
    function styleCard(node, pack) {
      node.style.setProperty('--hm-tp-accent', pack.color || '#f49898');
      [
        ['--hm-tp-border', pack.borderColor],
        ['--hm-tp-badge-bg', pack.badgeColor],
        ['--hm-tp-banner-bg', pack.bannerColor],
        ['--hm-tp-badge-size', pack.badgeSize ? pack.badgeSize + 'px' : ''],
        ['--hm-tp-banner-size', pack.bannerSize ? pack.bannerSize + 'px' : ''],
        ['--hm-tp-sub-size', pack.subtitleSize ? pack.subtitleSize + 'px' : ''],
      ].forEach(function (rule) {
        if (rule[1]) node.style.setProperty(rule[0], rule[1]);
      });
    }

    function render() {
      box.textContent = '';
      state.packs.forEach(function (pack) {
        var selected = pack.id === state.pack;
        var row = el('button', 'hm-tp__row' + (selected ? ' is-selected' : ''));
        row.type = 'button';
        row.setAttribute('aria-pressed', selected ? 'true' : 'false');
        styleCard(row, pack);
        if (pack.badge) row.appendChild(el('span', 'hm-tp__badge', pack.badge));
        var name = el('span', 'hm-tp__name', pack.title);
        if (pack.subtitle) name.appendChild(el('span', 'hm-tp__sub', pack.subtitle));
        row.appendChild(name);
        var price = el('span', 'hm-tp__price');
        if (pack.compare) price.appendChild(el('s', 'hm-tp__was', pack.compare));
        price.appendChild(el('strong', '', pack.price));
        row.appendChild(price);
        var banner = pack.banner ? el('span', 'hm-tp__banner', pack.banner) : null;
        row.addEventListener('click', function () {
          select(pack.id);
        });
        var item = companionItem(companion(pack));
        if (selected && item && item.variants.length) {
          // El biberón se elige dentro del propio pack.
          var card = el('div', 'hm-tp__card is-selected');
          styleCard(card, pack);
          card.appendChild(row);
          card.appendChild(optionsPanel(pack, item));
          if (banner) card.appendChild(banner);
          box.appendChild(card);
        } else {
          if (banner) row.appendChild(banner);
          box.appendChild(row);
        }
      });
    }

    function properties(form) {
      var props = {};
      form.querySelectorAll('[data-hm-prop]').forEach(function (input) {
        var match = /^properties\[(.+)\]$/.exec(input.name);
        if (match && input.value) props[match[1]] = input.value;
      });
      return props;
    }

    function addSet(form, pack, button) {
      var variant = form.querySelector('input[name="id"]');
      var variantId = variant ? Number(variant.value) : 0;
      if (!variantId) return;
      var bundle = uuid();
      var base = properties(form);
      var items = [];
      var count = units(pack);
      for (var i = 1; i <= count; i += 1) {
        var props = {};
        Object.keys(base).forEach(function (key) {
          props[key] = base[key];
        });
        props._bundle_id = bundle;
        props._bundle_title = pack.title;
        props._hm_pack = pack.id;
        props._tipo = 'tetina';
        props._hm_locale = locale;
        props._hm_n = String(i); // distinto en cada línea: Shopify no las junta en una de cantidad 2
        items.push({ id: variantId, quantity: 1, properties: props });
      }
      var other = companion(pack);
      var otherVariant = other ? companionVariant(pack) : null;
      if (other) {
        if (!otherVariant) {
          window.alert(msg('bundle.add_error', 'No se pudo añadir el pack al carrito.'));
          return;
        }
        items.push({
          id: Number(otherVariant.id),
          quantity: other.qty,
          properties: {
            _bundle_id: bundle,
            _bundle_title: pack.title,
            _hm_pack: pack.id,
            _tipo: other.role === 'otro' ? '' : other.role,
            _hm_locale: locale,
          },
        });
      }
      var payload = { items: items };
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (section) {
          return section.id;
        });
        payload.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'cart');
            return data;
          });
        })
        .then(function (response) {
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'happymami-teat-packs', cartData: response });
          }
          if (cart && typeof cart.renderContents === 'function' && response.sections) {
            if (!response.key && response.items && response.items[0]) response.key = response.items[0].key;
            cart.renderContents(response);
            return;
          }
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (failure) {
          var text = failure && failure.message && failure.message !== 'cart' ? failure.message : msg('bundle.add_error', 'No se pudo añadir el pack al carrito.');
          window.alert(text);
        })
        .then(function () {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        });
    }

    // La validación de la tetina (happymami-teat.js) corre antes en captura y frena el envío si falta
    // algo; este manejador solo ve formularios válidos.
    document.addEventListener(
      'submit',
      function (event) {
        var pack = current();
        var form = event.target;
        if (!pack || units(pack) < 2 || !form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var button = form.querySelector('[type="submit"]');
        if (button && button.getAttribute('aria-disabled') === 'true') return;
        addSet(form, pack, button || form);
      },
      true
    );

    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (!data || !data.packs) return;
        // Solo los packs que son únicamente esta tetina.
        state.packs = data.packs
          .filter(function (pack) {
            if (!pack.slots.length) return false;
            var others = pack.slots.filter(function (slot) {
              return !isOwnTeat(slot);
            });
            // Esta tetina y, como mucho, una pieza más con sus variantes.
            return others.length < pack.slots.length && others.length <= 1 && (!others.length || companionItem(others[0]));
          })
          .sort(function (a, b) {
            return units(a) - units(b) || (companion(a) ? 1 : 0) - (companion(b) ? 1 : 0);
          });
        if (state.packs.length < 2) return;
        // El pack preseleccionado en la app; si no hay, el primero.
        state.pack = state.packs[0].id;
        state.packs.forEach(function (pack) {
          if (pack.id === data.defaultPack) state.pack = pack.id;
        });
        select(state.pack);
        box.hidden = false;
        // Los packs ya enseñan sus precios: el precio suelto de la ficha se oculta al acabar el cuestionario.
        if (info) info.classList.add('hm-has-bundles');
        render();
      })
      .catch(function () {});
  }

  function boot() {
    document.querySelectorAll('[data-hm-teat-packs]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('product-info:loaded', boot);
})();
